import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
    ErrorMessageBar,
    InputError,
    InputLabel,
} from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import {
    FormComponent,
    FormWrapper,
    DatesWrapper,
    DateInputWrapper,
} from 'src/domains/layouts/shared/cms/form/Form.style';
import {
    EventName,
    SelectHeader,
    PickSelections,
    PickSingleSelections,
    PickSelectionButton,
    PickedSelectionWrapper,
    MovableItemWrapper,
    DragAndDropIconWrapper,
    ActionButtonsWrapper,
} from './HomePageCarouselForm.style';
import { ButtonOnInputSide } from 'src/domains/layouts/shared/buttons/Button.style';
import { UploadImg } from 'src/components/UploadImg/UploadImg';
import { HomePageCarouselFilter } from './HomePageCarouselFilter';
import { HomePageCarouselDateState } from './HomePageCarouselDateState';
import DatePicker from 'react-datepicker';
import { List as MovableList } from 'react-movable';
import { HomePageCarouselSelectionState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselSelectionState';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { InputRow } from 'src/domains/layouts/shared/formComponents/input/Input.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { HomePageCarouselState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { Select } from 'src/domains/layouts/shared/formComponents/Select/components/Select';
import { Textarea } from 'src/domains/layouts/shared/formComponents/textarea/Textarea';
import { ParagraphDefault, Label } from 'src/domains/layouts/shared/typography/Content.style';
import { PromoCarouselTranslationsForm } from './PromoCarouselTranslationsForm';
import { AddTranslationButton } from 'src/domains/layouts/shared/cms/translationsForm/CmsTranslationsForm.style';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

interface SelectionItemComponentPropsType {
    selectionId: number;
    isDragged: boolean;
    selectionItem: HomePageCarouselSelectionState;
    handleRemoveSelection: (selectionId: number) => void;
}

const SelectionItemComponent = observer(
    ({ selectionId, isDragged, selectionItem, handleRemoveSelection }: SelectionItemComponentPropsType) => {
        return (
            <PickedSelectionWrapper>
                <PickSingleSelections>
                    <div data-test='selected-name'>
                        {selectionItem.name} - {selectionItem.id}
                    </div>
                    <ActionButtonsWrapper>
                        <PickSelectionButton onClick={(): void => handleRemoveSelection(selectionId)}>
                            -
                        </PickSelectionButton>
                        <span data-movable-handle>
                            <DragAndDropIconWrapper isDragged={isDragged} />
                        </span>
                    </ActionButtonsWrapper>
                </PickSingleSelections>
                <div>
                    {selectionItem.fieldName === null ? null : (
                        <Input
                            label='Selection label'
                            isEmpty={selectionItem.fieldName.value === ''}
                            formInputState={selectionItem.fieldName}
                        />
                    )}
                </div>
            </PickedSelectionWrapper>
        );
    }
);
interface HomePageCarouselBettingFormPropsType {
    carouselPromoState: HomePageCarouselState;
}

export const HomePageCarouselBettingForm = observer(({ carouselPromoState }: HomePageCarouselBettingFormPropsType) => {
    const [state] = useState(() => new HomePageCarouselDateState(carouselPromoState));
    const { onChangeStartDate, onBlurStartDate, onChangeEndDate, onBlurEndDate, startDateError, endDateError } = state;
    const {
        title,
        subtitle,
        eventId,
        tcText,
        bgColor,
        startDate,
        endDate,
        uploadIcon,
        selectedDevice,
        deviceOptions,
        onChangeDevice,
        marketId,
        marketsOptions,
        isEventValid,
        eventModel,
        handleCheckEvent,
        handlePickSelection,
        selectedMarketId,
        selectionsOptions,
        eventName,
        selectedSelections,
        getSelectionItemById,
        handleRemoveSelection,
        clearSelections,
        isEditMode,
        isLoading,
        handleReset,
        handleEdit,
        handleCreate,
        handleFiltersOrder,
        errorMessageBetting,
        isDefaultPromo,
        languagesState,
        idsList,
        stakeFactor,
    } = carouselPromoState;

    const common = useCommon();
    const configState = ConfigState.get(common);

    return (
        <FormWrapper>
            <HomePageCarouselFilter carouselPromoState={carouselPromoState} />
            <ParagraphDefault>
                Betting Promos are cards with odds in that when pressed, will populate in the betslip. After entering a
                valid event, if you wish to add another language, click the Add Language button below.
            </ParagraphDefault>
            <FormComponent
                onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                    e.preventDefault();
                }}
            >
                <Loader isActive={isLoading} />

                {isEditMode === false ? (
                    <InputRow>
                        <Input
                            formInputState={eventId}
                            label='Event ID *'
                            isError={isEventValid === false}
                            isEmpty={eventId.value === ''}
                            dataTest='betting-event-id'
                        />
                        <ButtonOnInputSide
                            size='regular'
                            version='secondary'
                            disabled={isEventValid === false}
                            data-test='check-event-button'
                            onClick={handleCheckEvent}
                        >
                            Find event
                        </ButtonOnInputSide>
                    </InputRow>
                ) : null}

                {eventModel !== null && (
                    <>
                        {errorMessageBetting !== null && <ErrorMessageBar>{errorMessageBetting}</ErrorMessageBar>}
                        <EventName data-test='betting-event-name'>{eventName}</EventName>

                        <SelectHeader>Select market:</SelectHeader>

                        <Select
                            dataTest='select-market'
                            selectOptions={marketsOptions}
                            stateValue={marketId}
                            onChangeCB={clearSelections}
                        />

                        {selectedMarketId !== null && (
                            <PickSelections data-test='selection-list'>
                                {selectionsOptions.length > 0 ? (
                                    <>
                                        <SelectHeader>Pick selections:</SelectHeader>

                                        {selectionsOptions.map((elem) => {
                                            return (
                                                <PickSingleSelections key={elem.key}>
                                                    <div data-test='selection-name'>{elem.name}</div>
                                                    <PickSelectionButton
                                                        data-test='pick-selection-button'
                                                        onClick={(): Promise<void> => handlePickSelection(elem.key)}
                                                    >
                                                        +
                                                    </PickSelectionButton>
                                                </PickSingleSelections>
                                            );
                                        })}
                                    </>
                                ) : null}

                                {selectedSelections.length > 0 ? (
                                    <>
                                        <SelectHeader>Selected selections:</SelectHeader>

                                        <MovableList
                                            values={selectedSelections}
                                            onChange={handleFiltersOrder}
                                            renderList={({ children, props }): React.ReactNode => (
                                                <div {...props}>{children}</div>
                                            )}
                                            renderItem={({ value, props, isDragged }): JSX.Element | null => {
                                                const selectionItem = getSelectionItemById(value);
                                                return (
                                                    <MovableItemWrapper {...props}>
                                                        <SelectionItemComponent
                                                            data-test='selected-market'
                                                            selectionId={value}
                                                            isDragged={isDragged}
                                                            selectionItem={selectionItem}
                                                            handleRemoveSelection={handleRemoveSelection}
                                                        />
                                                    </MovableItemWrapper>
                                                );
                                            }}
                                        />
                                    </>
                                ) : null}
                            </PickSelections>
                        )}

                        <Textarea
                            label='Title'
                            formState={title}
                            isEmpty={title.value === ''}
                            dataTest='betting-promo-title'
                        />

                        <Textarea
                            label='Subtitle'
                            formState={subtitle}
                            isEmpty={subtitle.value === ''}
                            dataTest='betting-promo-subtitle'
                        />

                        <Textarea
                            label='Terms'
                            formState={tcText}
                            isEmpty={tcText.value === ''}
                            ckeditor
                        />

                        <>
                            {carouselPromoState.formsIds.map((item) => {
                                const state = carouselPromoState.getTranslationFormStateById(item);
                                return (
                                    <PromoCarouselTranslationsForm
                                        key={item}
                                        promoTranslationsState={state}
                                        promoCarouselState={carouselPromoState}
                                        languagesState={languagesState}
                                        isDefaultPromo={isDefaultPromo}
                                        formId={item}
                                    />
                                );
                            })}
                            {carouselPromoState.formsIds.length === 0 &&
                            languagesState.getNonDefaultLanguagesList().length > 0 ? (
                                <AddTranslationButton
                                    addAnotherForm={false}
                                    version='secondary'
                                    width='full'
                                    onClick={carouselPromoState.addLanguageForm}
                                >
                                    Add language
                                </AddTranslationButton>
                            ) : null}
                        </>

                        <Input
                            label='Background color (#hex value only)'
                            formInputState={bgColor}
                            isEmpty={bgColor.value === ''}
                            dataTest='betting-background-colour'
                        />

                        <UploadImg
                            title='Image'
                            uploadImageState={uploadIcon}
                            hideDeleteButton={configState.config.hideDeleteImageButtonOnHomePageCarousel}
                        />

                        <DatesWrapper>
                            <DateInputWrapper isEmpty={startDate === null}>
                                <InputLabel isEmpty={startDate === null}>Start date *</InputLabel>
                                <DatePicker
                                    id='Start-date'
                                    selected={startDate}
                                    onChange={onChangeStartDate}
                                    onBlur={onBlurStartDate}
                                    showTimeSelect
                                    timeFormat='HH:mm'
                                    timeIntervals={15}
                                    timeCaption='time'
                                    dateFormat='MMMM d, yyyy h:mm aa'
                                />
                                {startDateError ? <InputError>This field is required.</InputError> : null}
                            </DateInputWrapper>
                            <DateInputWrapper isEmpty={endDate === null}>
                                <InputLabel isEmpty={endDate === null}>End date *</InputLabel>
                                <DatePicker
                                    id='End-date'
                                    selected={endDate}
                                    onChange={onChangeEndDate}
                                    onBlur={onBlurEndDate}
                                    showTimeSelect
                                    timeFormat='HH:mm'
                                    timeIntervals={15}
                                    timeCaption='time'
                                    dateFormat='MMMM d, yyyy h:mm aa'
                                />
                                {endDateError ? <InputError>This field is required.</InputError> : null}
                            </DateInputWrapper>
                        </DatesWrapper>

                        <Select
                            label='Select device'
                            stateValue={selectedDevice}
                            selectOptions={deviceOptions}
                            defaultText='Select device'
                            onChangeCB={onChangeDevice}
                        />

                        <Label>
                            Display this promotion only to the following users (optional): [user ids separated by
                            commas].
                        </Label>

                        <Textarea
                            placeholder='Use comma or line break to separate user ids'
                            formState={idsList}
                        />

                        <Label>Display this promotion only to users with specified settings.</Label>
                        <Select
                            label='Exclude promo banned customers'
                            stateValue={carouselPromoState.promoBannedCustomerValue}
                            selectOptions={carouselPromoState.promoBannedCustomerOptions}
                            defaultText='Select option'
                            onChangeCB={carouselPromoState.onChangePromoBannedCustomerOptions}
                        />

                        <Select
                            label='Hidden when logged in'
                            stateValue={carouselPromoState.hiddenLoggedInValue}
                            selectOptions={carouselPromoState.hiddenLoggedInOptions}
                            defaultText='Select option'
                            onChangeCB={carouselPromoState.onChangeHiddenLoggedInOptions}
                        />

                        <Select
                            label='Toggle to show only if customer is email opted in or out'
                            stateValue={carouselPromoState.emailOptedValue}
                            selectOptions={carouselPromoState.emailOpteSwitchdOptions}
                            defaultText='Select option'
                            onChangeCB={carouselPromoState.onChangeEmailOptedOptions}
                        />

                        <Select
                            label='Stake factor type'
                            stateValue={carouselPromoState.stakeFactorValue}
                            selectOptions={carouselPromoState.stakeFactorSwitchOption}
                            defaultText='Select stake factor type'
                            onChangeCB={carouselPromoState.onChangeStakeFactorOptions}
                        />
                        {carouselPromoState.stakeFactorValue === 'list' ? (
                            <Input
                                formInputState={stakeFactor}
                                isEmpty={stakeFactor.value === ''}
                                label='For users with the specified stake factor as list e.g. 1.2, 2.3, 3.4'
                                dataTest='stake-factor'
                            />
                        ) : null}
                        {carouselPromoState.stakeFactorValue === 'range' ? (
                            <DatesWrapper>
                                <DateInputWrapper isEmpty={startDate === null}>
                                    <Input
                                        formInputState={carouselPromoState.stakeFactorRangeMin}
                                        isEmpty={carouselPromoState.stakeFactorRangeMin.value === ''}
                                        label='Min stake factor (inclusive)'
                                        dataTest='stake-factor-range-min'
                                    />
                                </DateInputWrapper>
                                <DateInputWrapper isEmpty={startDate === null}>
                                    <Input
                                        formInputState={carouselPromoState.stakeFactorRangeMax}
                                        isEmpty={carouselPromoState.stakeFactorRangeMax.value === ''}
                                        label='Max stake factor (inclusive)'
                                        dataTest='stake-factor-range-max'
                                    />
                                </DateInputWrapper>
                            </DatesWrapper>
                        ) : null}

                        <FormButtons
                            onCreate={handleCreate}
                            onUpdate={handleEdit}
                            onCancel={handleReset}
                            isEditMode={isEditMode}
                            dataTestCreate='create-betting-promo'
                            dataTestUpdate='update-betting-promo'
                        />
                    </>
                )}
            </FormComponent>
        </FormWrapper>
    );
});
